import { render, staticRenderFns } from "./CommunicationWizard.vue?vue&type=template&id=d591f114&scoped=true"
import script from "./CommunicationWizard.vue?vue&type=script&lang=js"
export * from "./CommunicationWizard.vue?vue&type=script&lang=js"
import style0 from "./CommunicationWizard.vue?vue&type=style&index=0&id=d591f114&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d591f114",
  null
  
)

export default component.exports